import { render, staticRenderFns } from "./PushHistory.vue?vue&type=template&id=2145c770&"
import script from "./PushHistory.vue?vue&type=script&lang=js&"
export * from "./PushHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports